import React from 'react';
import { connect } from 'react-redux';

import { Link } from 'layouts/header';
import { importStatic } from 'utils';

import GoogleAdBanner from '../components/googleAdBanner';

class Footer extends React.Component {
  render() {
    const { hideFooter, hideOnlyFooter, showSalesContactInfo } = this.props;

    const ContactInfo = () => (
      <>
        <p className="footer-text">
          Email: <span className="email-text">support@zippia.com</span>
        </p>
      </>
    );

    const SalesContactInfo = () => (
      <article className='z-mb-16'>
        <p className='semi-bold-font text-uppercase h6 mt-0'>Contact Sales:</p>
        <p className="footer-text">
          Email: <a href='mailto:sales@zippia.com' className="email-text">sales@zippia.com</a>
        </p>
        <p className="footer-text mb-0">
          Phone: <span className='white-text semi-bold-text'>(205) 947-2651</span>
        </p>
      </article>
    );

    return !hideFooter || !hideOnlyFooter ? (
      <footer className="footer">
        <div className="container">
          <div className="row mb-5">
            <div className="col-12">
              <GoogleAdBanner
                style={{
                  height: '125px',
                  maxHeight: '125px',
                  width: '100%',
                }}
                adSlot="3654063223"
              />
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row  footer-nav ">
            <div className="col-md-3 col-12 footer-logo mb-3 mb-md-0">
              <Link
                href="/"
                onClick={() => {
                  window.location.href = '/';
                }}
              >
                <img
                  width="153"
                  height="36"
                  src={importStatic('/ui-router/logo/medium.png')}
                  alt="Zippia"
                />
              </Link>
              <GoogleAdBanner
                style={{
                  height: '255px',
                  maxHeight: '255px',
                  width: '100%',
                  margin: '0 auto',
                }}
                adSlot="3930036028"
              />
              {/* <div className="footer-nav">
                            <ul className="social-icons">
                                <li><a href="https://www.facebook.com/Zippia"><i className="fa fa-facebook"></i></a></li>
                                <li><a href="https://plus.google.com/+ZippiaInc"><i className="fa fa-google-plus"></i></a></li>
                                <li><a href="https://twitter.com/ZippiaInc"><i className="fa fa-twitter"></i></a></li>
                            </ul>
                        </div> */}
            </div>
            <div className="col-md-3 col-6">
              <div className="semi-bold-font text-uppercase h6 mt-0">Zippia</div>
              <ul className="p-0 m-0">
                <li>
                  <a href="/about-us/"> About Us</a>
                </li>
                <li>
                  <a href="/employer/">Employer Services</a>
                </li>
                <li>
                  <a href="/terms-of-use/">Terms of Use</a>
                </li>
                <li>
                  <a href="/privacy-policy/">Privacy Policy</a>
                </li>
                <li>
                  <a href="/contact-us/">Contact Us</a>
                </li>
              </ul>
            </div>
            <div className="col-md-3 col-6">
              <div className="semi-bold-font text-uppercase h6 mt-0 footer-career-jobs">
                Careers & Jobs
              </div>
              <ul className="p-0 m-0">
                <li>
                  <a href="/resume-builder/?src=footer">Resume Builder</a>
                </li>
                <li>
                  <a href="/answers/">Job Search Q&A</a>
                </li>
              </ul>
            </div>
            <div className="col-md-3 col-12 mt-4 mt-md-0">
              {showSalesContactInfo ? <SalesContactInfo /> : <ContactInfo />}
              <p className="footer-text">{`Copyright © ${new Date().getFullYear()} Zippia, Inc.`}</p>
            </div>
          </div>
        </div>
      </footer>
    ) : null;
  }
}

export default connect(
  ({ locals }) => ({
    hideFooter: !!locals.hideFooter,
    hideOnlyFooter: !!locals.hideOnlyFooter,
  }),
  null
)(Footer);
